import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { ApiError } from "components";
import { RoleForm } from "./components/RoleFoem";
import { updateRole } from "modules/auth/role/store/action";
import {
  CreateRoleInput,
  RoleError,
  RoleProps,
  UpdateRoleInput,
} from "modules/auth/role/store/actionType";
type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  roleData: RoleProps;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUpdateRole: React.FC<Props> = ({
  closeModal,
  onUpdateRle,
  roleData,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<CreateRoleInput>({
    name: roleData?.name,
    description: roleData?.description,
  });
  const [error, setError] = useState<RoleError>({});
  const [apiError, setApiError] = useState(null);
  const roleState = useSelector((state: any) => state.roles?.genericRoleState);
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    const input = {
      name: formData.name,
      description: formData.description,
      id: roleData.id.toString(),
    };
    if (formData.name.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        name: "Role Name is required",
      }));
    }

    if (formData.description.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        description: "Role Description is required",
      }));
    }
    if (formData.name.trim() !== "" && formData.description.trim() !== "") {
      setSubmitted(true);
      setLoading(true);
      try {
        await onUpdateRle(input);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (submitted) {
      if (roleState.error) {
        setApiError(roleState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [roleState.error, submitted, closeModal]);
  return (
    <>
      <RoleForm
        handleSubmit={handleSave}
        formData={formData}
        handleChange={handleChange}
        errors={error}
        loading={loading}
        header={"Update Roles"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateRle: (input: UpdateRoleInput) => dispatch(updateRole(input)),
});
export default connect(null, mapDispatchToProps)(HandleUpdateRole);
